import { Component, OnInit, OnDestroy } from "@angular/core";
import { AuthService } from "app/core/services/auth.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "app/core/services/user.service";
import { CurrentUserService } from "app/core/services/current-user.service";
import { Loading } from "app/core/models/loading";

import { User } from "app/core/models/user";
import { CustomError } from "app/core/models/custom-error";

@Component({
  selector: "app-activate",
  templateUrl: "./activate.component.html",
  styleUrls: ["./activate.component.scss"]
})
export class ActivateComponent implements OnInit, OnDestroy {
  token: string;
  loading = new Loading(true, "Activating your account...");
  activated: boolean = false;
  activationError: CustomError;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private currentUserService: CurrentUserService
  ) { }

  async ngOnInit() {

    this.activated = false;

    //logout currently logged in user, if any
    this.authService.logout();
    // this.currentUserService.logoutUser();

    const activationToken = this.route.snapshot.queryParams["token"];

    try {
      let accessToken = await this.authService.activateUser(activationToken);

      let token: any = {
        access_token: accessToken,
        expires_in: 0
      };

      this.authService.storeTokenInLocalStorage(token);

      const user = await this.userService.getUser();
      this.currentUserService.setCurrentUser(user);

      this.loading.isLoading = false;
      this.activated = true;

      //redirect
      setTimeout(() => {
        this.router.navigate(["/user"]);
      }, 3000);

    }
    catch (error) {
      this.activationError = error;

      this.loading.isLoading = false;
      this.activated = false;
    }



  }

  ngOnDestroy() {
    // console.log("On Destroy");
  }
}
